import { mapActions } from "vuex";

export default {

  created() {
    this.setStoreCode(process.env.VUE_APP_STORE_CODE);
  },

  methods: {
    ...mapActions(["setStoreCode"]),
    ...mapActions(["setCurrentStoreView"]),
    ...mapActions(["setStoreViewsObject"]),

    setStoreView(){
      const storeViews = process.env.VUE_APP_STORE_VIEWS.split(',');
      this.$store.dispatch('setStoreUrlPrefix', '');
      this.setCurrentStoreView();
     
      // we loop through each storeView url prefix to append it to our api calls if necessary
      storeViews.forEach((value) => {
        this.setStoreViewsObject(value)
          
        if(window.location.href.includes(process.env.VUE_APP_API_BASE_URL+'/'+value)){
        
          this.setCurrentStoreView(value);
          this.$store.dispatch('setStoreUrlPrefix', '/'+value); 
        }
      });
    }
  }
};
